import { CameraPermissionContext } from '@views/contexts'
import { useContext } from 'react'

export const useCameraPermission = () => useContext(CameraPermissionContext)
